var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_3814)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.7883,
    y: 1.34961,
    width: 74.8472,
    height: 74.8472,
    rx: 16,
    transform: "rotate(12 26.7883 1.34961)",
    fill: "#077882",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 24.3037,
    width: 73.8472,
    height: 73.8472,
    rx: 15.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4993 61.3754C36.8393 61.3754 36.1793 61.2104 35.5793 60.8954L25.8143 55.6304C24.9293 55.1504 24.3743 54.2054 24.3743 53.1554C24.3743 52.1054 24.9293 51.1604 25.8143 50.6804L35.5793 45.4154C36.7793 44.7704 38.2193 44.7704 39.4043 45.4154L49.1693 50.6804C50.0543 51.1604 50.6093 52.1054 50.6093 53.1554C50.6093 54.2054 50.0543 55.1504 49.1693 55.6304L39.4043 60.8954C38.8193 61.2254 38.1593 61.3754 37.4993 61.3754ZM37.4993 47.1704C37.2143 47.1704 36.9143 47.2454 36.6443 47.3954L26.8943 52.6454C26.6393 52.7804 26.6243 53.0654 26.6243 53.1554C26.6243 53.2454 26.6393 53.5304 26.8943 53.6504L36.6593 58.9154C37.1993 59.2004 37.8143 59.2004 38.3543 58.9154L48.1193 53.6504C48.3593 53.5154 48.3893 53.2304 48.3893 53.1554C48.3893 53.0654 48.3743 52.7804 48.1193 52.6604L38.3543 47.3954C38.0843 47.2454 37.7843 47.1704 37.4993 47.1704Z",
    fill: "#077882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1693 77.0797C33.7493 77.0797 33.3143 76.9747 32.9243 76.7797L23.8343 72.2497C22.3193 71.4847 21.3743 69.9547 21.3743 68.2597V59.6797C21.3743 58.7047 21.8693 57.8197 22.6943 57.3097C23.5343 56.7997 24.5393 56.7547 25.4093 57.1897L34.4993 61.7197C36.0143 62.4847 36.9593 63.9997 36.9593 65.7097V74.2897C36.9593 75.2647 36.4643 76.1497 35.6393 76.6597C35.1893 76.9447 34.6793 77.0797 34.1693 77.0797ZM24.1643 59.1397C24.0443 59.1397 23.9393 59.1847 23.8793 59.2147C23.7893 59.2747 23.6243 59.4097 23.6243 59.6797V68.2597C23.6243 69.0997 24.0893 69.8647 24.8393 70.2397L33.9143 74.7847C34.1543 74.9047 34.3493 74.8147 34.4393 74.7697C34.5293 74.7097 34.6943 74.5747 34.6943 74.3047V65.7247C34.6943 64.8847 34.2293 64.1197 33.4793 63.7447L24.4043 59.1997C24.3143 59.1547 24.2393 59.1397 24.1643 59.1397Z",
    fill: "#077882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8293 77.08C40.3193 77.08 39.8093 76.945 39.3593 76.66C38.5343 76.15 38.0393 75.265 38.0393 74.29V65.71C38.0393 64.015 38.9843 62.485 40.4993 61.72L49.5743 57.175C50.4443 56.74 51.4643 56.785 52.2893 57.295C53.1143 57.805 53.6093 58.69 53.6093 59.665V68.245C53.6093 69.94 52.6643 71.47 51.1493 72.235L42.0743 76.78C41.6843 76.99 41.2493 77.08 40.8293 77.08ZM50.8343 59.14C50.7593 59.14 50.6843 59.155 50.5943 59.2L41.5193 63.745C40.7693 64.12 40.3043 64.87 40.3043 65.725V74.305C40.3043 74.575 40.4693 74.71 40.5593 74.77C40.6493 74.83 40.8443 74.905 41.0843 74.785L50.1593 70.24C50.9093 69.865 51.3743 69.1 51.3743 68.26V59.68C51.3743 59.41 51.2093 59.275 51.1193 59.215C51.0593 59.185 50.9543 59.14 50.8343 59.14Z",
    fill: "#077882"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_3814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.9996,
    height: 100,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder);
export default __webpack_public_path__ + "static/media/noOrder.077684f551f894ee0cc81993da32540b.svg";
export { ForwardRef as ReactComponent };